import routerOptions0 from "/usr/src/app/content/n3-treatments-450e3fd7-d575-458d-b82d-b8c302cfb9cd/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}